import { theme } from '@citygross/design-tokens';
import { EQuantitySelectorSize } from '../components/QuantitySelector/QuantitySelector.types.js';

var getQuantitySelectorSizeAttributes = function getQuantitySelectorSizeAttributes(size) {
  var _a, _b, _c, _d, _e, _f;

  switch (size) {
    case EQuantitySelectorSize.small:
      return {
        fontSize: (_b = (_a = theme.typography) === null || _a === void 0 ? void 0 : _a.size) === null || _b === void 0 ? void 0 : _b.s2,
        height: (_c = theme.spacings) === null || _c === void 0 ? void 0 : _c.lg
      };

    case EQuantitySelectorSize.large:
      return {
        fontSize: (_e = (_d = theme.typography) === null || _d === void 0 ? void 0 : _d.size) === null || _e === void 0 ? void 0 : _e.s2,
        height: (_f = theme.spacings) === null || _f === void 0 ? void 0 : _f.xl
      };

    default:
      return {};
  }
};

export { getQuantitySelectorSizeAttributes };